import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';

@Component({
  selector: 'app-absences-management',
  templateUrl: './absences-management.component.html',
  styleUrls: ['./absences-management.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTabNav, MatTabLink, RouterLinkActive, RouterLink, MatTabNavPanel, RouterOutlet],
})
export class AbsencesManagementComponent implements OnInit {
  protected activatedRoute = inject(ActivatedRoute);

  navLinks: any[] = [
    {
      label: 'Vacaciones',
      link: './vacations',
      index: 0,
    },
    {
      label: 'Peticiones de ausencias',
      link: './absence-requests',
      index: 1,
    },
  ];

  queryParams: any = {};

  ngOnInit(): void {
    this.listenQueryParams();
  }

  private listenQueryParams() {
    this.activatedRoute.queryParamMap.subscribe((data: any) => {
      const params = data.params;
      this.queryParams = params;
    });
  }
}
